import { Card } from "@/app/admin/_common/ui/card";
import CuoEmpty from "@/app/admin/_common/CuoEmpty";
import ShowThumbnail from "@/app/admin/_common/ShowThumbnail";
import type { GuestOrderRow } from "@/app/_services/GuestService";
import { Receipt, Ticket } from "lucide-react";

const currencyFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export default function GuestOrdersCard({ orders }: { orders: GuestOrderRow[] }) {
  return (
    <Card className="flex max-h-[320px] flex-col rounded-none border-0 px-2 py-4 shadow-none md:rounded-md md:border md:px-4">
      <div className="mb-5 flex-none text-[16px] font-semibold text-foreground sm:mb-3 sm:text-[13.5px]">
        Orders <span className="font-normal text-muted-foreground">· {orders.length} total</span>
      </div>
      {orders.length === 0 ? (
        <div className="flex flex-1 items-center justify-center">
          <CuoEmpty icon={Receipt} text="No orders yet" />
        </div>
      ) : (
        <div className="min-h-0 flex-1 overflow-y-auto">
          {orders.map((order) => (
            <div
              key={order.id}
              className="flex items-center gap-3 border-b border-border/50 py-2 last:border-0"
            >
              <ShowThumbnail
                src={order.img_url}
                alt={order.show_title ?? undefined}
                style={{ height: 36, width: 36, borderRadius: 6, flexShrink: 0 }}
              />
              <div className="min-w-0 flex-1">
                <div className="truncate text-[13px] text-foreground">{order.show_title ?? "Show"}</div>
                <div className="truncate text-[11.5px] text-muted-foreground">
                  {order.variant_name ?? "—"}
                </div>
              </div>
              <div className="flex-none text-right">
                <div className="text-[13px] font-medium text-foreground">
                  {currencyFormat.format(order.price)}
                </div>
                <div className="inline-flex items-center justify-end gap-1 text-[13px] font-medium text-foreground">
                  <Ticket className="size-3.5 flex-none text-muted-foreground" /> × {order.quantity}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
